<template>
    <label v-if="titleElement" :class="titleClass" :for="id">
        <b>
            {{ titleElement }}
        </b>
        <b class="text-danger ms-1" v-if="isRequired">*</b>
    </label>

    <select
        class="form-select vf-input "
        :class="onGetClasses"
        :name="name"
        :id="id"
        :disabled="disabled"
        :placeholder="placeholder"
        @input="onUpdateModelValue"
        @change="onChange"
        :data-automation="`select-${ id }`"
    >
        <option
            v-for="(option,index) in options"
            :key="index"
            :value="option.value"
            :selected="onSelectedOption(index, option.value, optionSelected)"
            :data-automation="`select-option-${ index }`"
        >
            {{ option.name }}
        </option>
    </select>

    <span v-if="textBelow" :class="classBelow">{{ textBelow }}</span>
</template>

<script>
    import { formProps } from '@/mixins';
    import { useVFSelect } from '@/composables';
    export default {
        name: "VF-select",
        props: {
            options: Object,
            optionSelected: {
                type: String,
                default: ''
            }
        },
        mixins: [
            formProps
        ],
        setup(props, { emit }) {
            const {
                modelValue,
                size,
                valid,
                vfClass,
                onGetClasses,
                onSelectedOption,
                onUpdateModelValue
            } = useVFSelect(props, emit);


            const onChange = (event) => {
                emit('change', event.target.value); // Emitimos el evento change con el valor actualizado
            };

            return {
                modelValue,
                size,
                valid,
                vfClass,
                onGetClasses,
                onSelectedOption,
                onUpdateModelValue,
                onChange
            };
        }
    };
</script>
